import { useTheme } from "@mui/material"

export function useDarkMode() {
    return useTheme().palette.mode !== "light"
}
